export default "/images/d49f8ce01e4f4a8592725bfe31604593.avif";